import Vue from 'vue'
import Vuex from 'vuex'
import axios from "axios";
import {UserViewModel} from "@/models/UserViewModel";

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    loggedInUser: null as UserViewModel | null ,
  },
  mutations: {
    setUser( state, payload ) {
      state.loggedInUser = payload;
    },
    // setDrainageAreaList( state , payload ) {
    //   state.drainageAreaList = payload;
    // },
    // setSewerageAreaList( state , payload ) {
    //   state.sewerageAreaList = payload;
    // },
    // setWorkAreaList( state , payload ) {
    //   state.workAreaList = payload;
    // },
    // setFacilityList( state , payload ) {
    //   state.facilityList = payload;
    // },
    // setMunicipalityList( state , payload ) {
    //   state.municipalityList = payload;
    // }
  },
  actions: {
    async updateUser( { commit } , payload ) {
      commit( 'setUser' , payload );
    },
    // retrieveUserInfo({ commit, dispatch }) {
    //   if (window.localStorage.getItem('loggedInUser')) {
    //     //@ts-ignore
    //     const loggedInUser = JSON.parse(window.localStorage.getItem('loggedInUser'))
    //     commit('setUser', loggedInUser)
    //   }
    //   //dispatch('getUserInfo')
    // },
    async getUserInfo({ commit }) {

      //this.$router.push('/Login');

      // try {
      //   const res = await axios.get('/User/GetUserInfo', {
      //     withCredentials: true
      //   } );
      //   const data = res.data;
      //   commit('setUser', data);
      // }
      // catch (err) {
      //   console.log(err.response)
      // }
    },
    // async getDrainageAreaList( { commit } ) {
    //   try {
    //     const res = await axios.get("/DrainageAreas/GetList");
    //     const data = res.data;
    //     commit('setDrainageAreaList' , data );
    //   }
    //   catch ( err ) {
    //     console.log(err.response);
    //   }
    // },
    // async getSewerageAreaList( { commit } ) {
    //   try{
    //     const res = await axios.get('/SewerageAreas/GetList');
    //     const data = res.data;
    //     commit('setSewerageAreaList' , data );
    //   }
    //   catch (err ) {
    //     console.log(err.response);
    //   }
    // },
    // async getFacilityList( { commit } ) {
    //   try {
    //     const res = await axios.get( '/Lookups/GetFacilities');
    //     const data = res.data;
    //     commit( 'setFacilityList' , data);
    //   } catch ( err ) {
    //     console.log(err.response);
    //   }
    // },
    // async getWorkAreaList( { commit } ) {
    //   try{
    //     const res = await axios.get('/Lookups/GetWorkAreas');
    //     const data = res.data;
    //     commit('setWorkAreaList' , data );
    //   }
    //   catch( err ) {
    //     console.log(err.response);
    //   }
    // },
    // async getMunicipalityList( { commit }) {
    //   try {
    //     const res = await axios.get( '/Municipalities/GetList');
    //     const data = res.data;
    //     commit('setMunicipalityList' , data );
    //   }
    //   catch (err) {
    //     console.log( err.response );
    //   }
    // },
    // storeUserToLocalStorage({ state }) {
    //   window.localStorage.setItem('user', JSON.stringify(state.user))
    // },
  },
  getters: {
    isUserLoaded: state => {
      return ( !!state.loggedInUser && !!state.loggedInUser.email && state.loggedInUser.email.length > 0 )
    },
    isSystemAdministrator: state => {
      return ( !!state.loggedInUser && state.loggedInUser.isSystemAdmin )
    },
    isMetroVanExtensionEditor: state => {
      return ( !!state.loggedInUser && state.loggedInUser.isMetroVanUser && ( state.loggedInUser.isExtensionsUser || state.loggedInUser.isExtensionsAdminUser || state.loggedInUser.isExtensionsLwoUser ) )
    },
    isMetroVanAmendmentEditor: state => {
      return ( !!state.loggedInUser && state.loggedInUser.isMetroVanUser && ( state.loggedInUser.isAmendmentsUser || state.loggedInUser.isAmendmentsAdminUser) )
    },
    isMunicipalUser: state => {
      return ( !!state.loggedInUser && state.loggedInUser.isMunicipalUser )
    }
  },
  modules: {
  }
})
